import React, { useEffect } from "react";
import styled from "styled-components";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getLineUUID } from "src/api/line";

const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding-top: 70px;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  background-repeat: repeat;
  position: unset;
  display: ${(props) => (props.show ? "none" : "block")};
  height: 100vh;
`;

const WrapperContent = styled.div`
  position: relative;
  display: flex;
`;

const DivBackgroundImage = styled.div`
  width: 100%;
  height: 500px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center; /* Center loading spinner */
`;

const WrapperBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  max-height: 600px;
  position: relative;
`;

const WrapperImg = styled.div`
  width: 100%;
`;

const Line = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  let code = searchParams.get("code");
  let state = searchParams.get("state");

  const fetchUUID = async () => {
    let parsedState;
    try {
      parsedState = JSON.parse(state);
    } catch (error) {
      console.error("Failed to parse state:", error);
      return;
    }

    const { callback: parsedCallback, uuid: LineId } = parsedState;

    const param = `code=${code}&state=${LineId}&callback=${window.location.origin + parsedCallback}`;

    await getLineUUID(param)
      .then(async (result) => {
        return navigate(`/${parsedCallback}`);
      })
      .catch((err) => {
        return navigate("/seller-shipping/list");
      });
  };

  useEffect(() => {
    fetchUUID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <WrapperContent>
        <WrapperImg>
          <WrapperBackgroundImage>
            <DivBackgroundImage>
              <CircularProgress />
            </DivBackgroundImage>
          </WrapperBackgroundImage>
        </WrapperImg>
      </WrapperContent>
    </Container>
  );
};

export default Line;
